import React, { useState } from "react";
import TextFieldCom from "@mui/material/TextField";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "../Tooltip/Tooltip";

import { InputAdornment } from "@mui/material";
import styles from "./TextFieldCount.module.css";

const TextFieldCount = (props) => {
  const {
    label,
    validation,
    error,
    required,
    placeholder,
    value,
    handleChange,
    helperText,
    FieldErrorLabel,
    FieldLabelHelperText,
    count,
    disabled,
  } = props;

  return (
    <div className={styles.TextField}>
      <div className={styles.TextFieldLabelContainer}>
        <div className={styles.FieldLabel}>
          <span>{label}</span>{" "}
          {required && <span style={{ color: "#d32f2f" }}>*</span>}&nbsp;
          {props.TooltipStatus && (
            <Tooltip
              TooltipText={props.TooltipText}
              Tooltip={
                <InfoOutlinedIcon sx={{ fontSize: "18px !important" }} />
              }
            />
          )}
        </div>
        <span className={styles.FieldLabelErrorText}>
          {(error || validation) &&
            FieldErrorLabel &&
            (FieldLabelHelperText ? FieldLabelHelperText : "Required")}
        </span>
      </div>
      <TextFieldCom
        className={styles.inputField}
        id="outlined-basic"
        variant="outlined"
        error={error || validation}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        helperText={helperText}
        disabled={disabled ? disabled : false}
        inputProps={{
          maxLength: count,
        }}
      />
      <span className={styles.FieldCount}>
        {count && value && (
          <span style={{ color: "#B6B9B9", alignSelf: "flex-end" }}>
            {" "}
            {value.length} / {count}
          </span>
        )}
      </span>
      {/* <span className={styles.FieldCount}>
        {count && value && (
          <span style={{ color: "#B6B9B9", alignSelf: "flex-end" }}>
            {" "}
            CHAR {value.length} / {count}
          </span>
        )}
      </span> */}
      {/* temporary disabled by sujan */}
      {/* <a className="AvailableButton">Available?</a> */}
    </div>
  );
};

export default TextFieldCount;
